import React, { useMemo } from 'react';
import StepTracker from '../StepTracker';

const ElectionSetupProgress = ({ election, style }) => {
  const { steps, currentStep } = useMemo(() => {
    if (!election) {
      return { steps: [], currentStep: 0 };
    }

    const setup = election.setup || {};
    // Check if election requires a precedent
    const needsPrecedent = (election.runoffPrecedent || election.primaryPrecedent);
    
    // Determine steps based on whether we need precedents
    // Order: Dates -> Ballot Overview -> Coverage Plan -> Precedent (if needed)
    const stepNames = needsPrecedent 
      ? ['Dates', 'Ballot Overview', 'Coverage Plan', 'Precedent']
      : ['Dates', 'Ballot Overview', 'Coverage Plan'];

    // Determine which step we're on
    let currentStepIndex = 0;
    
    if (needsPrecedent) {
      // 4-step flow: Dates -> Ballot Overview -> Coverage -> Precedent
      if (!setup.dates) {
        currentStepIndex = 0; // Dates
      } else if (!setup.ballotOverview) {
        currentStepIndex = 1; // Ballot Overview
      } else if (!setup.coverage) {
        currentStepIndex = 2; // Coverage
      } else if (!setup.precedents) {
        currentStepIndex = 3; // Precedent
      } else {
        currentStepIndex = 3; // All complete, show last step
      }
    } else {
      // 3-step flow: Dates -> Ballot Overview -> Coverage
      if (!setup.dates) {
        currentStepIndex = 0; // Dates
      } else if (!setup.ballotOverview) {
        currentStepIndex = 1; // Ballot Overview
      } else if (!setup.coverage) {
        currentStepIndex = 2; // Coverage
      } else {
        currentStepIndex = 2; // All complete, show last step
      }
    }

    // Build steps array with completion status
    const steps = stepNames.map((name) => {
      let isComplete = false;
      
      if (name === 'Precedent') {
        isComplete = setup.precedents || false;
      } else if (name === 'Dates') {
        isComplete = setup.dates || false;
      } else if (name === 'Ballot Overview') {
        isComplete = setup.ballotOverview || false;
      } else if (name === 'Coverage Plan') {
        isComplete = setup.coverage || false;
      }
      
      return {
        name,
        isComplete
      };
    });

    return { steps, currentStep: currentStepIndex };
  }, [election]);

  if (!election || steps.length === 0) {
    return null;
  }

  return <StepTracker steps={steps} currentStep={currentStep} style={style} />;
};

export { ElectionSetupProgress };
